import type { ReactNode } from 'react';
import s from './EmptyState.module.css';
import { Icon, type IconName } from './Icon';

/** An invitation to the next step, never an apology. */
export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  icon: IconName;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={s.root}>
      <span className={s.icon}>
        <Icon name={icon} size={26} />
      </span>
      <h2 className="t-title3">{title}</h2>
      {children && <div className={`${s.body} muted`}>{children}</div>}
      {action && <div className={s.action}>{action}</div>}
    </div>
  );
}
